export type ReportColumnGroup = 'batch' | 'client' | 'claim'

export interface ReportColumn {
    key: string
    label: string
    group: ReportColumnGroup
}

export const REPORT_COLUMNS: ReportColumn[] = [
    { key: 'batch_id', label: 'Batch ID', group: 'batch' },
    { key: 'introducer', label: 'Introducer', group: 'batch' },
    { key: 'audit_removed', label: 'Audit Removed', group: 'batch' },
    { key: 'audit_removed_reason', label: 'Removal Reason', group: 'batch' },
    { key: 'audit_removed_date', label: 'Removal Date', group: 'batch' },
    { key: 'title', label: 'Title', group: 'client' },
    { key: 'first_name', label: 'First Name', group: 'client' },
    { key: 'last_name', label: 'Last Name', group: 'client' },
    { key: 'dob', label: 'DOB', group: 'client' },
    { key: 'email_address', label: 'Email Address', group: 'client' },
    { key: 'phone_number', label: 'Phone Number', group: 'client' },
    { key: 'address_line_1', label: 'Address Line 1', group: 'client' },
    { key: 'address_line_2', label: 'Address Line 2', group: 'client' },
    { key: 'address_city', label: 'Address City', group: 'client' },
    { key: 'address_county', label: 'Address County', group: 'client' },
    { key: 'address_post_code', label: 'Address Post Code', group: 'client' },
    { key: 'address_country', label: 'Address Country', group: 'client' },
    { key: 'law_firm_case_reference', label: 'Law Firm Case Reference', group: 'claim' },
    { key: 'law_firm_secondary_reference', label: 'Law Firm Secondary Reference', group: 'claim' },
    { key: 'claimant_id', label: 'Claimant ID', group: 'claim' },
    { key: 'loan_value', label: 'Loan Value', group: 'claim' },
    { key: 'quantum_individual', label: 'Quantum Individual', group: 'claim' },
    { key: 'quantum_client_cumulative', label: 'Quantum Client Cumulative', group: 'claim' },
    { key: 'defendant', label: 'Defendant', group: 'claim' },
    { key: 'cfa_date', label: 'CFA Date', group: 'claim' },
    { key: 'agreement_number', label: 'Agreement Number', group: 'claim' },
    { key: 'incident_date', label: 'Incident Date', group: 'claim' },
    { key: 'law_firm', label: 'Law Firm', group: 'claim' },
    { key: 'fee_earner', label: 'Fee Earner', group: 'claim' },
    { key: 'facility', label: 'Facility', group: 'claim' },
    { key: 'ate_provider', label: 'ATE Provider', group: 'claim' },
    { key: 'ate_inception_date', label: 'ATE Inception Date', group: 'claim' },
    { key: 'ate_policy_number', label: 'ATE Policy Number', group: 'claim' },
    { key: 'ate_indemnity_limit', label: 'ATE Indemnity Limit', group: 'claim' },
    { key: 'ate_underwriter', label: 'ATE Underwriter', group: 'claim' },
    { key: 'ate_underwriter_email', label: 'ATE Underwriter Email', group: 'claim' },
    { key: 'ate_premium', label: 'ATE Premium', group: 'claim' },
    { key: 'loc_sent_date', label: 'LOC Sent Date', group: 'claim' },
    { key: 'agreement_end_date', label: 'Agreement End Date', group: 'claim' },
    { key: 'limitation_end_date', label: 'Limitation End Date', group: 'claim' },
    { key: 'outside_limitation', label: 'Outside Limitation', group: 'claim' },
    { key: 'client_status', label: 'Client Status', group: 'claim' },
    { key: 'iva', label: 'IVA', group: 'claim' },
    { key: 'closed', label: 'Closed', group: 'claim' },
    { key: 'fos_rejected', label: 'FOS Rejected', group: 'claim' },
    { key: 'affordability', label: 'Affordability', group: 'claim' },
    { key: 'plate_number', label: 'Plate Number', group: 'claim' },
    { key: 'omnibus_id', label: 'Omnibus ID', group: 'claim' },
    { key: 'documents_pack_url', label: 'Documents Pack URL', group: 'claim' },
    { key: 'agreement_start_date', label: 'Agreement Start Date', group: 'claim' },
    { key: 'monthly_repayment', label: 'Monthly Repayment', group: 'claim' },
    { key: 'contract_term', label: 'Contract Term', group: 'claim' },
    { key: 'starting_balance', label: 'Starting Balance', group: 'claim' },
]

export const DEFAULT_REPORT_COLUMNS = ['email_address', 'first_name', 'last_name', 'dob']

export const REPORT_COLUMN_GROUPS: { id: ReportColumnGroup; label: string }[] = [
    { id: 'batch', label: 'Batch' },
    { id: 'client', label: 'Client' },
    { id: 'claim', label: 'Claim' },
]
